// @flow
import * as React from 'react';

import { Base } from '@gandi/ui';
import { useTranslator } from '@gandi/translate';

import { InputTextField, SelectField, TextAreaField } from 'gandi.react-form';

import DomainNameField from './DomainNameField';

import Row from './Row';

type Props = {| category: string, topic?: string |};

type ChosenType = 'Company/Association' | 'Individual';

function HostingFields({ category, topic }: Props): React.Element<typeof Base> {
  const translator = useTranslator();
  const { __ } = translator;
  const showDomainName = category === 'domain' || topic === 'spam';
  const types: Array<{| text: string, value: ChosenType |}> = [
    {
      text: __('Company/Association'),
      value: 'Company/Association',
    },
    {
      text: __('Individual'),
      value: 'Individual',
    },
  ];
  const [chosenType, setChosenType] = React.useState<?ChosenType>();

  const onChangeType = (evt: SyntheticInputEvent<>) => {
    // $FlowFixMe[incompatible-call]: expect string but error says 'string is incompatible with literal union.'
    setChosenType(evt.target.value);
  };

  return (
    <Base backgroundColor="grey-lighter" padding="small" separatorBottom>
      {showDomainName && <DomainNameField category={category} topic={topic} />}

      {topic === 'spam' && (
        <>
          <TextAreaField
            name="params.mail_headers"
            label={__('Mail headers')}
            placeholder={__(
              'Indicate here the headers of the concerned emails.'
            )}
            required
          />
          <Row fullRow>
            <TextAreaField
              name="params.mail_body"
              label={__('Mail body')}
              placeholder={__(
                'Indicate here the content of the concerned email'
              )}
            />
          </Row>
        </>
      )}

      {topic === 'illegal' && (
        <Row fullRow>
          <InputTextField
            type="url"
            name="params.url"
            label={__('URL of the illegal content')}
            required
          />
        </Row>
      )}

      {topic === 'breaching' && (
        <>
          {/* Select type */}
          <Row>
            <Base className="for-2-columns">
              <SelectField
                label={__('You are')}
                placeholder={__('Choose...')}
                name="params.type"
                values={types}
                onChange={onChangeType}
                translator={translator}
                variant="block"
                required
              />
            </Base>
          </Row>

          {chosenType !== 'Individual' && (
            <>
              <Row>
                <Base className="for-2-columns">
                  <InputTextField
                    name="params.legal_form"
                    label={__('Company type')}
                    required
                  />
                </Base>
                <Base className="for-2-columns">
                  <InputTextField
                    name="params.denomination"
                    label={__('Company name')}
                    required
                  />
                </Base>
              </Row>
              <Row>
                <Base className="for-2-columns">
                  <InputTextField
                    name="params.headquarter"
                    label={__('Registered address')}
                    required
                  />
                </Base>
                <Base className="for-2-columns">
                  <InputTextField
                    name="params.representative"
                    label={__('Representative')}
                  />
                </Base>
              </Row>
              <Row>
                <Base className="for-2-columns">
                  <InputTextField
                    autoComplete="family-name"
                    name="params.name"
                    label={__('Last Name')}
                    required
                  />
                </Base>
                <Base className="for-2-columns">
                  <InputTextField
                    name="params.firstnames"
                    label={__('First Name')}
                    required
                    autoComplete="given-name"
                  />
                </Base>
              </Row>
            </>
          )}

          <Row>
            <Base className="for-2-columns">
              <InputTextField
                autoComplete="organization-title"
                name="params.profession"
                label={__('Profession')}
                required
              />
            </Base>
          </Row>

          <Row>
            <Base className="for-2-columns">
              <InputTextField
                name="params.address"
                label={__('Address')}
                required
                autoComplete="street-address"
              />
            </Base>
            <Base className="for-2-columns">
              <InputTextField
                name="params.nationality"
                label={__('Nationality')}
                required
              />
            </Base>
          </Row>
        </>
      )}

      {topic === 'pirated' && (
        <>
          <Row>
            <Base className="for-2-columns">
              <InputTextField
                inputMode="url"
                label={__('Source Ip')}
                name="params.source_ip"
                required
              />
            </Base>
            <Base className="for-2-columns">
              <InputTextField
                inputMode="url"
                label={__('Target Ip')}
                name="params.target_ip"
                required
              />
            </Base>
            <Base className="for-2-columns">
              <InputTextField
                label={__('Time of the attack')}
                name="params.hours"
                required
              />
            </Base>
          </Row>

          <Row fullRow>
            <TextAreaField
              label={__('Logs of the attack')}
              name="params.logs"
              placeholder={__('Paste attack logs here')}
              required
              rows={12}
            />
          </Row>
        </>
      )}

      {topic === 'malware' && (
        <Row fullRow>
          <InputTextField
            type="url"
            label={__('Exact malware location')}
            name="params.location"
            required
          />
        </Row>
      )}

      {topic === 'other' && (
        <Row fullRow>
          <InputTextField
            type="url"
            label={__('URL in question')}
            name="params.url"
            required
          />
        </Row>
      )}
    </Base>
  );
}

export default HostingFields;
